import cx from "classnames";
import styles from "./gradientBackground.module.scss";

interface GradientBackgroundProps {
  showGradient: boolean;
}

const GradientBackground: React.FC<GradientBackgroundProps> = ({ showGradient }) => {
  return (
    <div className={cx(
      styles.gradientCanvas,
      showGradient ? styles.active : '',
    )}
    ></div>
  )
}

export default GradientBackground;